import { $all, forEach, listenResize } from "@olmokit/dom";
import { breakpoints, gridGutter } from "@olmokit/core/scss";
import { glide, Anchors, LazyLoad, Swipe } from "@olmokit/core/glide";
import "components/Mosaic";
import "./mosaics.scss";

export default function collectionMosaicSliders(
  selector = ".mosaic:family__tiles"
) {
  const components = { Swipe, Anchors, LazyLoad };

  function getFirstSlide($container) {
    const $slides = $all(".glide__slide", $container);
    return $slides[0];
  }

  function getPerView($container, $firstSlide) {
    const slideWidth = Math.max(170 + gridGutter, $firstSlide.offsetWidth);
    const perView = $container.offsetWidth / slideWidth;
    return perView;
  }

  function doesItFit($container, $firstSlide, slidesQuantity) {
    const slideWidth = $firstSlide.offsetWidth;
    return $container.offsetWidth > slideWidth * slidesQuantity;
  }

  function getSlider($container) {
    const $firstSlide = getFirstSlide($container);

    const slider = glide($container, {
      loop: false,
      bound: true,
      perView: getPerView($container, $firstSlide),
    })
      .on("resize", () => responsiveCheck($container, slider))
      .on("mount.after", () => responsiveCheck($container, slider));

    return slider;
  }

  function responsiveCheck($container, slider) {
    const $slides = $all(".glide__slide", $container);
    const $firstSlide = $slides[0];
    const slidesQuantity = $slides.length;
    const perView = getPerView($container, $firstSlide);
    const itFits = doesItFit($container, $firstSlide, slidesQuantity);

    if (itFits || window.innerWidth >= breakpoints.xl) {
      $container.classList.add("is-fitting");
      // if (slider) slider.go("<<");
      // if (slider) slider.disable();
      if (slider) slider.destroy();
    } else {
      $container.classList.remove("is-fitting");
      if (slider) {
        slider.update({ perView });
        // slider.enable();
      } else {
        getSlider($container).mount(components);
      }
    }
  }

  forEach($all(selector), ($container) => {
    responsiveCheck($container);

    listenResize(() => responsiveCheck($container));
  });
}
